




















































import { Prop, Component, Vue } from "vue-property-decorator";
import {
  signInWithEmailAndPassword,
  signInWithSSOMicrosoft,
  UserType,
} from "../../services/firebaseAuths";
import { pushNotifcation } from "../../services/notification";
import { sessionsTracker } from "../../services/FirebaseQueries";

@Component({
  name:'SignIn',
  components: {}
})
export default class SignIn extends Vue {
  private step = 1;

  private nextStep() {
    console.log("Going to step -> ", 2);
    this.$emit("nextStep", 2);
  }

  // ? Login info.
  private email= "test@gmail.com";
  private password= "smoketest";
  private error = "";

  get fillEmail() {
    return this.email;
  }
  set fillEmail(event: string) {
    this.email = event;
  }

  get fillPass() {
    return this.password;
  }

  set fillPass(event: string) {
    this.password = event;
  }

  public async LoginWithNormalEmailAndPassword(event: any) {
    console.log(`Login with -> ${this.email} & ${this.password}`);
    const response: any = await signInWithEmailAndPassword(
      this.email,
      this.password
    );

    if (response.code === 200) {
      console.log("User Response -> ", response.data);
      console.log("Redirecting to Dashboard 😁 ");
      const notification: any = {
        title: `Welcome ${response.data.name} 😳`,
        body: "Today is good day to work with firebase 😏 🎈",
        icon:
          "https://www.pinclipart.com/picdir/big/548-5485193_iphone-7-push-technology-apple-push-notification-push.png",
      };

      pushNotifcation(notification);
  
      this.$router.replace({ name: "Dashboard" });
    } else {
      console.error("Ocurrio un error 😥 ");
      this.error = response;
    }
  }

  public async singleSignOnMs() {
    console.log(`Login With microsoft account`);
    const response: any = await signInWithSSOMicrosoft();

    if (response.code === 200) {
      console.log("User Response -> ", response.data);
      console.log("Redirecting to Dashboard 😁 ");

      const notification: any = {
        title: `Welcome ${response.data.name} 😳`,
        body: "Today is good day to work with firebase 😏 🎈",
        icon:
          "https://www.pinclipart.com/picdir/big/548-5485193_iphone-7-push-technology-apple-push-notification-push.png",
      };
      pushNotifcation(notification);
      this.$router.replace({ name: "Dashboard" });
    } else if (response.code === 400) {
      console.error("Ocurrio un error 😥 ");
      this.error = response;
    }
  }
}
